/**
 * @generated SignedSource<<9647bb5d97586c6f157cbda7a6b3d512>>
 * @relayHash f6334124a4ff726ae57c51b7eee081eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 391ad450d5f7fb477eb4a17333d024aa7c069ec3039e38699e40eaddf4899b98

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "391ad450d5f7fb477eb4a17333d024aa7c069ec3039e38699e40eaddf4899b98",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
